import React from 'react';

function LandingPageLiveDemo() {

    return (
        <div className="container center-block">
            <h1 className="col-sm-12 text-center">
                Live Demo
            </h1>
            <div className="videowrapper">
                <iframe title="Atila Live demo Video"
                        src="//www.youtube.com/embed/c_K4342WMwQ?cc_load_policy=1"
                        width="560" height="314">
                </iframe>
            </div>
        </div>
    );
}

export default LandingPageLiveDemo;
